module.exports = __webpack_public_path__ + "static/media/ic-haux-training-min.2b5e29ad.svg";